import { render } from "./LightboxCategoryBestSeller.vue?vue&type=template&id=74bdb32e"
import script from "./LightboxCategoryBestSeller.vue?vue&type=script&lang=js"
export * from "./LightboxCategoryBestSeller.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__